import {Dialog} from '@primer/react/experimental'

interface DiscardBatchConfirmationDialogProps {
  /**
   * Whether the dialog is open
   */
  isOpen: boolean
  /**
   * Callback when the user confirms the discard action
   */
  onConfirm: () => void
  /**
   * Callback when the user cancels or closes the dialog
   */
  onCancel: () => void
  /**
   * The number of suggestions in the batch
   */
  suggestionsCount: number
}

export function DiscardBatchConfirmationDialog({
  isOpen,
  onConfirm,
  onCancel,
  suggestionsCount,
}: DiscardBatchConfirmationDialogProps) {
  if (!isOpen) {
    return null
  }

  return (
    <Dialog
      title="Discard batch?"
      onClose={onCancel}
      footerButtons={[
        {content: 'Cancel', onClick: onCancel},
        {content: 'Discard', buttonType: 'danger', onClick: onConfirm},
      ]}
      width="medium"
    >
      <p>
        <span>Are you sure you want to discard this batch? This will remove all {suggestionsCount} </span>
        <span>{suggestionsCount === 1 ? 'suggestion' : 'suggestions'}</span>
        <span> from the batch.</span>
      </p>
    </Dialog>
  )
}
